import { render, staticRenderFns } from "./invest-cases-list.vue?vue&type=template&id=553d81cd"
import script from "./invest-cases-list.vue?vue&type=script&lang=js"
export * from "./invest-cases-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports